import script from "./financePage.vue?vue&type=script&setup=true&lang=js"
export * from "./financePage.vue?vue&type=script&setup=true&lang=js"

import "./financePage.vue?vue&type=style&index=0&id=2bbc2124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbc2124"]])

export default __exports__